var _rect, _rect2, _circle, _circle2, _line, _line2, _line3, _line4, _circle3, _circle4, _line5, _line6, _circle5, _text, _rect3, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverDrowsiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "driverGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3d1a2d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6f2d4d",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#driverGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 240,
    height: 150,
    rx: 10,
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 140,
    r: 35,
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 140,
    r: 8,
    fill: "#ffd93d"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 105,
    x2: 200,
    y2: 95,
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 175,
    x2: 200,
    y2: 185,
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 140,
    x2: 155,
    y2: 140,
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 140,
    x2: 245,
    y2: 140,
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 110,
    r: 8,
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 110,
    r: 8,
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 112,
    x2: 164,
    y2: 112,
    stroke: "#ff6b6b",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 236,
    y1: 112,
    x2: 244,
    y2: 112,
    stroke: "#ff6b6b",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 100,
    r: 20,
    fill: "#ff6b6b",
    opacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 110,
    textAnchor: "middle",
    fontSize: 20,
    fill: "white",
    fontWeight: "bold"
  }, "!")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 220,
    width: 220,
    height: 50,
    rx: 5,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 250,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#00ffff"
  }, "Eye Tracking \u2022 Face Recognition \u2022 Latency &lt;100ms")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverDrowsiness);
export default __webpack_public_path__ + "static/media/driver_drowsiness.b8a3ebcc81e3915a8ddbdbfb785b22c9.svg";
export { ForwardRef as ReactComponent };